/**
 * Liste dip toplamı (06.10.2026, Faturalanacaklar): görüntülenen satırların toplamı.
 * Satırlarda birden fazla döviz cinsi varsa toplam anlamsızdır; bu durumda "Farklı Döviz Cinsi" yazılır.
 */
export const FARKLI_DOVIZ = 'Farklı Döviz Cinsi';

export type DipToplamSonucu = { farkliDoviz: true } | { farkliDoviz: false, toplam: number };

export const dipToplam = <T,>(satirlar: T[], deger: (x: T) => number | undefined | null, doviz: (x: T) => string | undefined | null): DipToplamSonucu => {
    const dovizler = new Set(satirlar.map(x => doviz(x) ?? ''));

    if (dovizler.size > 1)
        return { farkliDoviz: true };

    return { farkliDoviz: false, toplam: satirlar.reduce((t, x) => t + (Number(deger(x)) || 0), 0) };
}
